import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'prizes',
    label: 'Prizes',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
